import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { completeGoogleAuth } from "../../services/auth.service";
import {
  signInWithGoogle,
  isGoogleSignInCancelled,
} from "../../services/googleAuth";

// Pass `idToken` when it was already obtained (redirect fallback result);
// otherwise the Google popup is opened. Must be dispatched straight from a
// click handler — no awaits before the popup, or Safari blocks it.
// Resolves with a null payload when the page is navigating to Google.
export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async ({ userType = "shop", idToken } = {}, { rejectWithValue }) => {
    try {
      const token = idToken || (await signInWithGoogle());
      if (!token) return null;
      return await completeGoogleAuth({ idToken: token, userType });
    } catch (error) {
      if (isGoogleSignInCancelled(error)) return rejectWithValue(null);
      return rejectWithValue(
        error.response?.data?.message || "Google sign-in failed"
      );
    }
  }
);

// export const googleLogin = createAsyncThunk(
//   "auth/googleLogin",
//   async (_, { rejectWithValue }) => {
//     try {
//       const provider = new GoogleAuthProvider();
//       const result = await signInWithPopup(auth, provider);

//       const idToken = await result.user.getIdToken();

//       const response = await api.post("/auth/signin/google", {
//         idToken,
//       });

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message || "Google sign-in failed"
//       );
//     }
//   }
// );

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    userData: null,
    token: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.userData = null;
      state.token = null;
      localStorage.removeItem("token");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(googleLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload) return;
        state.user = true;
        state.userData = action.payload.data?.user;
        state.token = action.payload.data?.token;

        if (action.payload.data?.token) {
          localStorage.setItem("token", action.payload.data.token);
        }
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
